import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Grid,
  TextField,
  IconButton,
  InputAdornment,
  Alert,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import styles from './styles';
import Edit from '@mui/icons-material/Edit';
import ChangeAffiliateKey from './ChangeAffiliateKey';

const PartnerInformation = ({
  email,
  affiliateLink,
  affiliateKey,
  isAdminView,
}: {
  email: string;
  affiliateLink: string;
  affiliateKey: string;
  isAdminView: boolean;
}) => {
  const [copySuccess, setCopySuccess] = useState<string>('');
  const [isChangeAffiliateKeyModalOpen, setIsChangeAffiliateKeyModalOpen] = useState<boolean>(
    false
  );

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(affiliateLink);
      setCopySuccess('Link copied!');
      setTimeout(() => setCopySuccess(''), 3000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <>
      <Box sx={{ p: 3, pb: 0 }}>
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12}>
            <Card sx={styles.card}>
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Affiliate Link"
                      value={affiliateLink}
                      variant="outlined"
                      size="small"
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleCopy}
                              size="small"
                              sx={{
                                bgcolor: '#000',
                                color: 'white',
                                borderRadius: 1,
                                '&:hover': {
                                  bgcolor: '#333',
                                },
                              }}
                            >
                              <ContentCopyIcon fontSize="small" />
                            </IconButton>
                            {!isAdminView && (
                              <IconButton
                                onClick={() => setIsChangeAffiliateKeyModalOpen(true)}
                                size="small"
                                sx={{
                                  ml: 0.5,
                                  color: '#000',
                                  bgcolor: '#fff',
                                  border: '1px solid #000',
                                  borderRadius: 1,
                                  '&:hover': {
                                    bgcolor: '#333',
                                  },
                                }}
                              >
                                <Edit fontSize="small" />
                              </IconButton>
                            )}
                          </InputAdornment>
                        ),
                      }}
                      fullWidth
                    />
                    {copySuccess && (
                      <Alert severity="success" sx={{ mt: 1, borderRadius: 1 }}>
                        {copySuccess}
                      </Alert>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Email"
                      value={email}
                      variant="outlined"
                      size="small"
                      InputProps={{ readOnly: true }}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>

      {isChangeAffiliateKeyModalOpen && !isAdminView && (
        <ChangeAffiliateKey
          existingAffiliateKey={affiliateKey}
          onModalClose={() => setIsChangeAffiliateKeyModalOpen(false)}
        />
      )}
    </>
  );
};

export default PartnerInformation;
